// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__4WCMq","author":"Table_author__23pse","authorImage":"Table_authorImage__2qENt","unreadRow":"Table_unreadRow__29U-y"};